import classNames from 'classnames'

import Image from '../ui/Image/Image'
import PillarsSection from './PillarsSection'
import UPIBenefits from './UPIBenefits'
import Card from '../ui/Card/Card'
import Markdown from '../Markdown/Markdown'
import useIsMobile from '../../hooks/useIsMobile'
import { getImageUrl } from '../../utils'
import Button from '../ui/Button/Button'
import arrowUpRight from '../../assets/images/arrowUpRight.svg'
import { useNavigate } from 'react-router-dom'

import styles from './UpiLayout.module.scss'

function UPIInfrastructure({ selectedCard }) {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const handleNavigation = (buttonDetails) => {
    if (buttonDetails?.isExternal) {
      return window.open(buttonDetails?.path, '_blank', 'noopener,noreferrer')
    }
    navigate(buttonDetails?.path)
  }
  return (
    <>
      <div className={styles.innerContainer}>
        <div
          className={classNames('page-container', styles.upibenefitsContainer)}
        >
          <h1>{selectedCard.upibenefitsheader}</h1>
          {selectedCard.upibenefits && (
            <UPIBenefits benefits={selectedCard.upibenefits} />
          )}
        </div>
        <PillarsSection
          title={selectedCard.piller_title}
          pillarsCards={selectedCard.piller_content}
          backgroundImage={selectedCard.piller_image}
        />
        {/* <div className={styles.cardsContainer}> */}
        {selectedCard.piller_content.map((pillar, index) => (
          <Card
            key={'pillar' + pillar?.id}
            className={classNames(styles.pillarCard)}
            style={{
              marginBottom:
                selectedCard.piller_content.length - 1 === index && '2.5rem',
            }}
          >
            <div className={styles.cardNumber}>{index + 1}</div>
            <div className={styles.cardContent}>
              <h2>{pillar.heading}</h2>
              <p>{pillar.description}</p>
            </div>
          </Card>
        ))}
        {/* </div> */}
        <div className={classNames(styles['parallax-container'])}>
          <div
            className={classNames(
              'page-container',
              styles.missionCardContainer
            )}
          >
            <Card className={styles.missionCard}>
              <div className={classNames(styles.leftSectionContainer)}>
                <div className={styles.missionCardTextContainer}>
                  <div className={classNames(styles.title)}>
                    {selectedCard?.meteoric_title}
                  </div>
                  {!isMobile && (
                    <>
                      <Markdown
                        className={classNames(styles.markdown)}
                        content={selectedCard?.meteoric_description}
                      />
                    </>
                  )}
                </div>
                {!isMobile && selectedCard?.button && (
                  <Button
                    aria-label={selectedCard?.button?.label}
                    classname={styles.countryListButton}
                    buttonDetails={selectedCard?.button}
                    text={selectedCard?.button?.label}
                    handleClick={handleNavigation}
                  >
                    <Image
                      src={arrowUpRight}
                      alt={selectedCard?.button?.label}
                      className={styles.btnImage}
                    />
                  </Button>
                )}
              </div>
              <Image
                src={getImageUrl(selectedCard.meteoric_image)}
                alt={selectedCard?.meteoric_image?.alternativeText}
                className={classNames(styles.image)}
              />
              {isMobile && (
                <div>
                  <Markdown
                    contentClass={classNames(styles.description)}
                    content={selectedCard?.meteoric_description}
                  />
                  {selectedCard?.button && (
                    <Button
                      aria-label={selectedCard.button?.label}
                      classname={styles.countryListButton}
                      buttonDetails={selectedCard?.button}
                      text={selectedCard?.button?.label}
                      handleClick={handleNavigation}
                    >
                      <Image
                        src={arrowUpRight}
                        alt={selectedCard?.button?.label}
                        className={styles.btnImage}
                      />
                    </Button>
                  )}
                </div>
              )}
            </Card>
          </div>
        </div>
      </div>
    </>
  )
}

export default UPIInfrastructure
